var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_has.js
// module id = 11
// module chunks = 7